import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminEditLesson() {
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [lesson_date, setLessonDate] = useState('');
  const [youtube_link, setYoutubeLink] = useState('');
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const navigate = useNavigate();
  const fetchLesson = useCallback(async () => {
    setFetching(true);
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to edit a lesson.');
        setMessageType('error');
        setFetching(false);
        return;
      }
      const response = await axios.get(`${apiUrl}/api/admin/lessons/${id}?nocache=${Date.now()}`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        const lesson = response.data.lesson;
        setTitle(lesson.title || '');
        setSummary(lesson.summary || '');
        setLessonDate(lesson.lesson_date ? lesson.lesson_date.substring(0, 10) : '');
        setYoutubeLink(lesson.youtube_link || '');
        setFiles(lesson.files || []);
      } else {
        setMessage(response.data.message || 'Failed to fetch lesson.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error fetching lesson.');
      setMessageType('error');
    } finally {
      setFetching(false);
    }
  }, [id]);
  useEffect(() => {
    fetchLesson();
  }, [fetchLesson]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to edit a lesson.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const response = await axios.put(`${apiUrl}/api/admin/lessons/${id}`, {
        title, summary, lesson_date, youtube_link
      }, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setMessage('Lesson updated successfully!');
        setMessageType('success');
        setTimeout(() => navigate('/admin-view-batches'), 1500);
      } else {
        setMessage(response.data.message || 'Failed to update lesson.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error updating lesson.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <Link to="/admin-view-batches" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    View Batches
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Edit Lesson</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Edit Lesson</h4>
              {message && (
                <div className={`alert alert-${messageType} mb-16`}>
                  {message}
                </div>
              )}
              {fetching ? (
                <div className="alert alert-info mb-0" role="alert">
                  Loading lesson...
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="mb-24">
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="summary" className="form-label">Summary</label>
                    <textarea
                      className="form-control"
                      id="summary"
                      value={summary}
                      onChange={(e) => setSummary(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="lesson_date" className="form-label">Lesson Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="lesson_date"
                      value={lesson_date}
                      onChange={(e) => setLessonDate(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="youtube_link" className="form-label">YouTube Link</label>
                    <input
                      type="url"
                      className="form-control"
                      id="youtube_link"
                      value={youtube_link}
                      onChange={(e) => setYoutubeLink(e.target.value)}
                    />
                  </div>
                  {files.length > 0 && (
                    <div className="mb-4">
                      <label className="form-label">Attached Files</label>
                      <ul>
                        {files.map((file) => (
                          <li key={file.id}>
                            <a href={`${apiUrl}/${file.filepath}`} target="_blank" rel="noopener noreferrer">
                              {file.title || 'Untitled File'}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Lesson'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminEditLesson;
